<template>
    <v-container fluid>       
      <v-card
        color="grey lighten-3"
      >
        <v-list-item>
          <v-list-item-avatar v-if="stallholderData.stallholder_type"
            :color="getStallholderColor(stallholderData.stallholder_type)"
            class="headline font-weight-light white--text"
            >
            {{ stallholderData.stallholder_type.charAt(0).toUpperCase() }}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="headline">{{stallholderData.stall_name}}</v-list-item-title>
            <v-list-item-subtitle>{{stallholderData.first_name}} {{stallholderData.last_name}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-text>
          <mailto-btn v-if="stallholderData.length" :email="stallholderData.email"></mailto-btn>
          {{stallholderData.email}}
        </v-card-text>

        <v-alert
          v-if="stallholderData.admin_note"
          outlined
          icon="mdi-account-alert"
          text
          color="error"
          class="mx-4"
        >
        {{stallholderData.admin_note}}
        </v-alert>

        <v-card-actions>
          <v-btn text @click="openStallholderDialog()">Edit</v-btn>
          <v-spacer></v-spacer>
          <v-btn text :href="stallholderData.profile_url" target="_blank">
            View Profile Page
            <v-icon right dark>mdi-open-in-new</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <BookingsTable v-if="stallholder_id"
      :stallholder_id="stallholder_id"
      :key="stallholder_id"
      />

      <StallholderDialog
        :dialogVisible="isStallholderDialogVisible"
        :selectedStallholder="stallholderData"
        @close="closeStallholderDialog"
        @update="updateStallholder"
      />

      <BookingModal
        :dialogVisible="$store.state.dialogs.booking"
        :selectedItem="selectedBooking"
        :key="selectedBooking.id"
        @close="$store.commit('setDialogVisibility', { 'dialog': 'booking', 'value': false})"
      />
        <!-- <BookingModal
        :dialogVisible="this.$store.state.dialog.booking"
        :selectedStall="selectedBooking"
        :selectedDate="date"
        @close="dialogClose"
        @save="dialogSave"
        @create="createBooking"
        @update="updateBooking"
      /> -->

      <v-overlay :value="isLoading" z-index="1000">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

    </v-container>
</template>

<script>

import axios from 'axios';
import BookingsTable from '../components/BookingsTable';
import StallholderDialog from '../components/StallholderDialog';
import BookingModal from '../components/BookingModal';
import MailtoBtn from '../components/MailtoBtn';

import { mapGetters } from 'vuex'
import store from '../store'

export default {
  data: () => ({
    stallholder_id: null,
    isLoading: true,
    isStallholderDialogVisible: false,
    isBookingDialogVisible: false,
    //selectedBookingId: false,
    bookingData: [],
  }),
  components: {
    BookingsTable,
    BookingModal,
    StallholderDialog,
    MailtoBtn
  },
  methods: {
    getBookings(){
        let self=this;

        this.isLoading = true;

        axios.get(`/wisdom-markets/v1/bookings/?stallholder_id=${stallholder.id}`, {
            headers: {
                'Authorization': `Bearer ${this.$store.state.accessToken}`,
            },
            })
            .then(function (response) {
                console.warn('lili', response);

                let data = response.data;
                
                self.bookingData = data; // replace all old posts with new results

                self.isLoading = false

            })
            .catch(function (error) {
                console.log(error);
                console.log("why thefick!!!");
            })
            .then(function () {
                // always executed
            });  
    },
    openStallholderDialog () { 
      this.isStallholderDialogVisible = true
    },
    closeStallholderDialog () { 
      this.isStallholderDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      // setTimeout(() => {
      //  this.selectedStallholderId = false;
      // }, 500)  
    },
    // openEditBookingDialog (id) { 
    //   //this.isBookingDialogVisible = true
    //   this.selectedBookingId = id;
    // },
    updateStallholder(){
      console.error('do we need to do anythign herereee?');
    }
  },
  computed: {
     ...mapGetters([
      'getBooking',
      'getStallholderById',
      'getStallholderColor',
      'getStallholderName',
      'getDefaultStallholderIdForStall',
      'getCategoryById',
      'getStoreStallholders',
      'getStallName' // this is only used incase the stall name gets updated we want the bookings/market list to be auto updated
    ]),
//     stallholderDataold() {
//       console.warn('the wwww');
// console.warn(this.stallholder_id  , ';sdaasd');
// //let lili = 'sakjdgkjadh';
//      let lili  = Object.assign({}, this.getStallholderById(this.stallholder_id)); // so we get new images in dialog otherwise not needed
//      console.warn('the wwwwgggggg');
//       console.warn(lili);

//       //return populateAmenitiesAndPrices(
//         if(!this.stallholder_id)
//           console.log('the fuck)');
//         //con sole.log('kkkk', this.stallholder_id);
// return this.stallholder_id;
//        //return {'lili':'asdads'}

//         return this.getStallholderById(this.stallholder_id)
//       //);
//     },

 stallholderDataAll() {
   return  this.getStoreStallholders;
 },
    stallholderData() {
      console.warn('ffff', this.stallholder_id);
            //return this.getStoreStallholders;

      //return {'asd': 'asdass'}
let lili = this.getStoreStallholders.filter(stallholder => stallholder.id == this.stallholder_id)

      if(lili && lili.length> 0) {
        this.isLoading = false;
        return {...lili[0]}
      }
//Object.assign({}, this.getStallholderById(this.stallholder_id))
      //return;
      return {}
// console.warn(this.stallholder_id  , ';sdaasd');
// //let lili = 'sakjdgkjadh';
//      //let lili  = Object.assign({}, this.getStallholderById(this.stallholder_id)); // so we get new images in dialog otherwise not needed
//      console.warn('the wwwwgggggg');
//       console.warn(lili);

//       //return populateAmenitiesAndPrices(
//         if(!this.stallholder_id)
//           console.log('the fuck)');
//         //con sole.log('kkkk', this.stallholder_id);
// return this.stallholder_id;
//        //return {'lili':'asdads'}

//         return this.getStallholderById(this.stallholder_id)
//       //);
    },
    selectedBooking() {
      //let booking = this.bookingData.find( booking => this.selectedBookingId == booking.id)
  console.log("whatsttsststt");
      if(this.$store.state.selected.bookingId)
        return this.getBooking(this.$store.state.selected.bookingId);
      else 
      return false
      
      //return booking
    },
  },
  watch: {
    getStoreStallholders(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      console.log({oldValue});
console.log({newValue});
console.log(this.stallholder_id);
      //this.stallholderData = this.getStallholderById(this.stallholder_id)


      // Do whatever makes sense now
      if (newValue === 'success') {
        this.complex = {
          deep: 'some deep object',
        };
      }
    },
  },
  beforeMount(){
    console.error(this.$route.params.id);
    this.stallholder_id=parseInt(this.$route.params.id);
  },
  beforeRouteUpdate (to, from, next) {
    this.isLoading = true;
     console.error('ffffu');
      this.stallholder_id=parseInt(to.params.id);

    //this.getContent(to.params.uid);
    redirectIfNotStallholder(to, from, next)

    next();
  }
}


async function redirectIfNotStallholder (to, from, next) {
    // const user = await getUserState()
    // if (user === null) {
    //   next({ name: 'auth' })
    // } else {
    //   next()

  
    // }
    console.warn({to})
console.log("h2222222222ave all hoder" +to.params.id, store.state.have_all_stallholders)
console.log("getting search for ");
console.warn(store.getters.getStallholderById(to.params.id));
    if(store.state.have_all_stallholders || store.getters.getStallholderById(to.params.id) ){
        console.log("we have datassss for ");
    }else{
        console.log("we need to fetch consle for "+to.params.id)
       
        const user = store.dispatch("loadStallholder", { id: to.params.id})
        .then(function (response) {
            // yay, you got a new phone
            console.log('fulfilled');
            console.log({response});
            //commit('addStallholder', response);
            store.commit('addStallholder', response);

        })
        .catch(function (error) {
            // oops, stallholde rnot found
            next({ name: 'stallholders' })
        });

        
    }
    next()

}


</script>

<style>

</style>